import { Card, Col, Row } from "react-bootstrap";
import Header from "./Header";
import "../App.css";
import Footer from "./Footer";
import { Helmet } from "react-helmet-async";
import about from '../Assets/images/about-vector.png'

function About() {
  return (
    <>
     <Helmet>
      <title>About Us - htmlh5games</title>
    </Helmet>
      <div className="contact">
        <Header />
        <div className="space">
        <Row className=" d-flex justify-content-center align-items-center mt-5">
              <h2 className="privacy-heading mb-5  text-center">About Us</h2>
              <Col xl={6} lg={6} md={12} className="d-flex justify-content-center">
              <img className="about-img" src={about} alt="" />
              </Col>
          <Col  xl={6} lg={6} md={12}  className="d-flex flex-column gap-4">
            <Card className="contact-card ">
              <div className="">
                <p className="contact-p">
                  Welcome to htmlh5games  Your Ultimate Online Gaming
                  Destination!
                </p>
                <p className="contact-p ">
                  At htmlh5games, we're passionate about delivering fun,
                  excitement, and entertainment through a wide range of engaging
                  online games. Whether you're a casual gamer or a hardcore fan,
                  we offer something for everyone  from thrilling action and
                  arcade games to relaxing puzzles and strategy challenges.
                </p>
              </div>
              </Card>
              
              
              <Card className="contact-card ">
              <div className="content-div">
                <h4 className="title">🎮 What We Offer</h4>
                <ul className="mb-0 d-flex flex-column gap-3">
                  <li className="contact-p">
                  <strong> Massive Game Collection:</strong>  Explore hundreds of popular and
                    trending games in one place.
                  </li>
                  <li className="contact-p">
                   <strong> Play Instantly:</strong> No downloads, no installs  just click and
                    play.
                  </li>
                  <li className="contact-p">
                  <strong> Free & Accessible: </strong>100% free games that work across all
                    devices.
                  </li>
                  <li className="contact-p">
                  <strong> Regular Updates:</strong> We add new games frequently so you'll never
                    run out of fun.
                  </li>
                  <li className="contact-p">
                  <strong> Kid Friendly & Family Fun:</strong> Safe and enjoyable for all age
                    groups.
                  </li>
                </ul>
              </div>
              </Card>
               </Col>
               </Row>
               {/* <Card className="contact-card mt-5 content" style={{ width: "100%" }}>
                           <div className="content-div ">
                             <ul className="mb-0">
                               <li className="title">About the developer</li>
                             </ul>
                              <p className="contact-p">Vadadoriya Bhaveshbhai Rameshbhai</p>
                             <div className="mt-2">
                               <p className="mb-1" style={{ color: "black" }}>
                                 Email :
                               </p>
                               <p className="contact-p">
                                 <a
                                   href="mailto:office.editorapp@gmail.com"
                                   style={{ color: "#ff5a3c" }}
                                 >
                                   office.editorapp@gmail.com
                                 </a>
                               </p>
                             </div>
               
                             <div className="mt-3">
                               <p className="mb-1" style={{ color: "black" }}>
                                 Location :
                               </p>
                              
                               <p className="contact-p">
                                 178, sant devidas soc.near santivan soc-2, sarthana jakatnaka,
                                 surat, Surat City, Surat, Gujarat - 395006
                               </p>
                             </div>
                           </div>
                         </Card> */}
               <div className="d-flex flex-column gap-4 mt-5">
              <Card className="contact-card ">
              <div className="content-div">
                <h4 className="title">❓ Why Choose Us?</h4>
                <ul className="mb-0 d-flex flex-column gap-3">
                  <li className="contact-p">
                  <strong> User Friendly Experience:</strong> Smooth, fast loading games with a sleek, easy to use interface.
                  </li>
                  <li className="contact-p">
                  <strong> Trusted Platform:</strong> Designed with player safety and data privacy in mind.
                  </li>
                  <li className="contact-p">
                  <strong>Passion for Gaming:</strong>  Created by gamers, for gamers  we understand what you love!
                  </li>
                </ul>
              </div>
              </Card>
              <Card className="contact-card ">
               <div className="content-div">
                <h4 className="title"> 💡 Our Vision</h4>
               <p className="contact-p">Our mission is to become one of India's most loved online gaming platforms  a place where joy meets technology, and where every user leaves with a smile.</p>
              </div>
              </Card>
            </div>
            </div>
         
        
        <Footer />
      </div>
    </>
  );
}

export default About;
